import request from '@/utils/request'

// 获取新闻列表
export function getNewsList() {
  return request({
    url: '/getNews',
    method: 'get'
  })
}

// 获取新闻详情
export function getNewsDetail(newsId) {
  return request({
    url: '/getNewsDetail',
    method: 'get',
    params: {
      news_id: newsId
    }
  })
}

